import { HandshakeIcon } from './HandshakeIcon';

/**
 * author: Michael Richins
 * id A41E35E2-6756-46D9-BE48-4DFA705A6A6A
 * name handshake
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/handshake.svg
 * tags
 */
export const DealIcon = HandshakeIcon;
export default DealIcon